














































































































































































import TitleBar from "@/components/Elements/TitleBar.vue";
import YearPicker from "@/components/Controls/YearPicker.vue";

import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { mapGetters, mapState, mapActions } from "vuex";

import { STORE_KEY, store } from "./_store";
import moment from "moment";
import ExcelJS from "exceljs";

@Component({
  computed: {
    ...mapState(STORE_KEY, ["loading", "loaded", "fatalError", "items"]),
  },
  methods: {
    ...mapActions(STORE_KEY, ["setReportOptions", "exportDataAsXLSX"]),
  },
  components: {
    TitleBar,
    YearPicker,
  },
})
class YearProductReport extends Vue {
  get titleStack() {
    return ["Отчеты", "По аналитике по годам и продуктам"];
  }

  localFilter: any = {
    show_transport_costs: false,
    group_by_product_type: false,
    years: [],
    product_type_ids: [],
  };
  months = moment.months();

  get currentMonth(): number {
    return moment().month();
  }

  get currentYear(): number {
    return moment().year();
  }

  /**
   * Проверяет, является ли месяц текущим для данного года
   * @param monthIdx - индекс месяца (0-11)
   * @param dataItems - массив данных с годами
   */
  isCurrentMonth(monthIdx: number, dataItems: any[]): boolean {
    // Проверяем, есть ли текущий год в данных
    const hasCurrentYear = dataItems.some(
      (d: any) => d.year == this.currentYear
    );
    return hasCurrentYear && monthIdx === this.currentMonth;
  }

  get defaultSort() {
    return [
      this.$route.query.sortField || "delivery_zone_address",
      this.$route.query.sortDirection || "asc",
    ];
  }

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    this.localFilter.show_transport_costs =
      this.$route.query && this.$route.query.show_transport_costs
        ? this.$route.query.show_transport_costs
        : null;
    // @ts-ignore
    this.localFilter.group_by_product_type =
      this.$route.query && this.$route.query.group_by_product_type
        ? this.$route.query.group_by_product_type
        : null;
    // @ts-ignore
    this.localFilter.product_type_ids =
      this.$route.query && this.$route.query.product_type_ids
        ? this.$route.query.product_type_ids
        : [];
    this.localFilter.product_type_ids = Array.isArray(
      this.localFilter.product_type_ids
    )
      ? this.localFilter.product_type_ids
      : [this.localFilter.product_type_ids];
    // @ts-ignore
    this.localFilter.years =
      this.$route.query && this.$route.query.years
        ? this.$route.query.years
        : [];
    this.localFilter.years = Array.isArray(this.localFilter.years)
      ? this.localFilter.years
      : [this.localFilter.years];

    this.handleParamsChange();
  }
  handlerInput(field: string, v: any) {
    if (!this.localFilter.years.includes(v)) {
      this.localFilter.years.push(v);
      this.localFilter.years = this.localFilter.years.sort(
        (a: number, b: number) => a - b
      );
    }
  }
  removeYear(year: number) {
    this.localFilter.years = this.localFilter.years.filter(
      (y: number) => y !== year
    );
  }

  onGroupByProductTypeChange(value: boolean) {
    if (value) {
      this.localFilter.show_transport_costs = false;
    }
  }

  tableToExcel(no_products: boolean = false) {
    const colors: any = {
      header: "FFFFFF",
      "row-weight": "bdd6ee",
      "row-income": "c5e0b3",
      "row-prime_cost": "ffe598",
      "row-profit": "ff66ff",
      "row-profit_percent": "c7c7c7",
      "row-transport-cost": "f5f5f5",
    };
    this.$store
      .dispatch(`${STORE_KEY}/exportData`)
      .then((csvContent: any[]) => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Отчет");
        csvContent.forEach((row: any, idx: number) => {
          const row_class: any = row[0];
          const _row: any = worksheet.addRow(row.slice(1));

          _row.eachCell({ includeEmpty: true }, function(
            cell: any,
            colNumber: number
          ) {
            console.log("Cell ", cell);
            if (colNumber > 2) {
              cell.numFmt = "0,0.00";
              cell.alignment = { vertical: "middle", horizontal: "center" };
            }
            if (idx == 0) {
              cell.style.font = {
                family: 2,
                size: 11,
                bold: true,
              };
            } else {
              cell.style.font = {
                family: 2,
                size: 11,
              };
            }
          });
          _row.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: colors[row_class] },
          };
        });
        worksheet.getColumn("A").width = 6;
        worksheet.getColumn("B").width = 40;
        for (let i = 3; i <= 15; i++) {
          worksheet.getColumn(i).width = 15;
        }
        worksheet.getColumn(16).width = 20;
        workbook.xlsx
          .writeBuffer()
          .then(function(xls64: any) {
            const a = document.createElement("a");
            const data = new Blob([xls64], {
              type:
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });

            const url = URL.createObjectURL(data);
            a.href = url;
            a.download = "export.xlsx";
            document.body.appendChild(a);
            a.click();
            setTimeout(function() {
              document.body.removeChild(a);
              window.URL.revokeObjectURL(url);
            }, 0);
          })
          .catch(function(error: any) {
            console.log(error.message);
          });
      });
  }

  setFilterData() {
    const query = Object.keys(this.localFilter).reduce((ac: any, key) => {
      // @ts-ignore
      ac[key] = this.localFilter[key];
      return ac;
    }, {});

    this.$router.replace({
      query,
    });
  }

  // ---------------------------------------------------------------------------

  @Watch("$route.query")
  public handleParamsChange() {
    this.$store.dispatch(`${STORE_KEY}/loadData`, this.$route.query);
  }
}

export default YearProductReport;
